import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";

export default function Angebote() {
  const { user } = useAuth();
  const [offers, setOffers] = useState([]);
  const [branches, setBranches] = useState([]);
  const [branchId, setBranchId] = useState("");

  useEffect(() => { api.get("/branches").then((r) => setBranches(r.data)); }, []);
  useEffect(() => {
    const q = branchId ? `?branch_id=${branchId}` : "";
    api.get(`/offers${q}`).then((r) => setOffers(r.data));
  }, [branchId]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
      <Seo title="Angebote – HELIUM Cafeteria" description="Aktuelle Angebote und Aktionen bei HELIUM: Kaffee-Deals, Lunch-Angebote und exklusive Vorteile für Treuemitglieder." />
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <span className="text-xs font-semibold uppercase tracking-wider text-[#E0243A]">Angebote</span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight mt-2 font-display">Aktuelle Aktionen</h1>
        </div>
        <select value={branchId} onChange={(e) => setBranchId(e.target.value)} className="px-4 py-2.5 rounded-xl border border-gray-200 bg-white font-medium" data-testid="offers-branch-selector">
          <option value="">Alle Standorte</option>
          {branches.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
        </select>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {offers.map((o) => {
          const locked = o.loyalty_required && (!user || user.role !== "customer");
          return (
            <div key={o.id} className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden" data-testid="offer-card">
              <div className="relative h-48">
                <img src={o.image} alt={o.title} className="w-full h-full object-cover" />
                {o.discount && <span className="absolute top-3 left-3 bg-[#E0243A] text-white text-xs font-bold px-2.5 py-1 rounded-full">-{o.discount}</span>}
                {o.loyalty_required && <span className="absolute top-3 right-3 bg-[#1F2937] text-white text-xs font-bold px-2.5 py-1 rounded-full flex items-center gap-1"><Lock className="w-3 h-3" />Vorteile</span>}
              </div>
              <div className="p-5">
                <h3 className="text-lg font-semibold">{o.title}</h3>
                <p className="text-sm text-gray-600 mt-1">{o.description}</p>
                <div className="mt-3 flex items-center gap-2">
                  <span className="text-2xl font-bold text-[#E0243A]">{o.price?.toFixed(2)} €</span>
                  {o.old_price && <span className="text-sm text-gray-400 line-through">{o.old_price?.toFixed(2)} €</span>}
                  {o.ma_price != null && o.ma_price !== "" && <span className="text-sm font-semibold text-gray-500">· MA {Number(o.ma_price).toFixed(2)} €</span>}
                </div>
                {locked ? (
                  <Link to="/registrieren" className="mt-4 block text-center bg-[#1F2937] text-white font-semibold py-2.5 rounded-xl text-sm">Für Mitglieder – jetzt beitreten</Link>
                ) : (
                  <p className="mt-4 text-xs text-gray-500">{o.terms}</p>
                )}
              </div>
            </div>
          );
        })}
        {offers.length === 0 && <p className="text-gray-500 col-span-full">Aktuell sind keine Angebote verfügbar.</p>}
      </div>
    </div>
  );
}
